import React, { useCallback } from "react";
import DatePicker from "react-datepicker";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
export const SearchBarDesktop = ({ dataSearch, setDataSearch, onSearch }) => {

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDataSearch(prev => ({ ...prev, [name]: value }));
    };

    const handleDateChange = (field) => (date) => {
        setDataSearch(prev => ({ ...prev, [field]: date }));
    };

    const handleSearch = useCallback(() => {
        const newSearchData = { ...dataSearch, pageIndex: 1 };
        onSearch(newSearchData);
    }, [onSearch, dataSearch]);

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };

    return (
        <div className="card border-light mb-1 show-table-main card-v2" onKeyDown={handleKeyDown}>
            <div className="card-body card-body-v2" style={{ padding: '12px 16px 8px 16px' }}>
                <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3 flex-wrap">
                    <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
                        <label className="font-color-default font-bold">Nhân viên</label>
                        <input
                            type="text"
                            name="nhanVien"
                            value={dataSearch.nhanVien}
                            onChange={handleInputChange}
                            className="form-control input-sm"
                            placeholder="Tên hoặc SĐT nhân viên"
                        />
                    </div>
                    <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
                        <label className="font-color-default font-bold">Từ ngày</label>
                        <DateTimePicker
                            value={dataSearch.fromDate}
                            onChange={handleDateChange("fromDate")}
                            placeholder="Chọn ngày"
                            maxDate={dataSearch.toDate}
                        />
                    </div>
                    <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
                        <label className="font-color-default font-bold">Đến ngày</label>
                        <DateTimePicker
                            value={dataSearch.toDate}
                            onChange={handleDateChange("toDate")}
                            placeholder="Chọn ngày kết thúc"
                            minDate={dataSearch.fromDate}
                        />
                    </div>
                    <div className="input-sm-new">
                        <button
                            type="button"
                            className="btn btn-info-new"
                            style={{ paddingTop: "7px" }}
                            onClick={handleSearch}
                        >
                            <i className="la la-search"></i>
                            <span> &nbsp; TÌM KIẾM</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};